module.exports = __webpack_public_path__ + "media/images/of1-b8fbd5b13eb4aebf37d5710cff636c64.jpg";